import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { StartupState } from './startup.state';
import { Logger } from '@core';

export abstract class StartupStep extends Function {
  protected state?: StartupState;
  protected readonly logger: Logger = inject(Logger);

  protected abstract executeStep(state: StartupState): Observable<StartupState>;

  constructor(state: StartupState) {
    super();
    return new Proxy(this, {
      apply: (): Observable<StartupState> => this.executeStep(state)
    });
  }
}
